import type { PlayerMe } from "@redchain/contracts";

export type PlayerLock = PlayerMe["locks"][number];

export function lockFor(me: PlayerMe | null | undefined, action: string): PlayerLock | null {
  return me?.locks?.find((row) => row.action === action) ?? null;
}

export function isLocked(me: PlayerMe | null | undefined, action: string): boolean {
  return lockFor(me, action)?.locked ?? false;
}
